// extracted by mini-css-extract-plugin
module.exports = {"preloader":"preloader_preloader__xq_Tm","rotation":"preloader_rotation__2-AUU","anim_rotation":"preloader_anim_rotation__3Rx61"};